// Third party
import { createReducer, on, Action } from '@ngrx/store';

// Local library
// import { AuthenticationActions } from '@amwager/authentication/data-access';

// Local file
import * as CommonActions from './common.actions';
import { ICommonState } from './common.models';



export const COMMON_FEATURE_KEY = 'common';
export interface ICommonPartialState {
  readonly [COMMON_FEATURE_KEY]: ICommonState;
}

const stateGuard = (state: ICommonState): ICommonState => state;


const reducer = createReducer(
  {},
  on(
    CommonActions.initState,
    CommonActions.clearState,
    () => stateGuard({
      id: 'common-state',
      name: 'common',
    })
  ),
  on(CommonActions.loadCommonSuccess, (state) => stateGuard({
    ...state as ICommonState,
    isLoaded: true
  })),
  on(CommonActions.loadCommonFailure, (state, { error }) => stateGuard({
    ...state as ICommonState,
    error
  })),


  /**
   * Log
   */
  on(CommonActions.log, (state, { message }) => stateGuard({
    ...state as ICommonState,
    log: message
  })),
  on(CommonActions.logSuccess, (state, { message }) => stateGuard({
    ...state as ICommonState,
    log: 'SUCCESS:' + message
  })),
  on(CommonActions.logError, (state, { message, typeError }) => stateGuard({
    ...state as ICommonState,
    error: (() => {
      console.error(typeError);
      return message;
    })()
  })),


  /**
   * Properties
   */
  on(CommonActions.setIsComponentView, (state, { isComponentView }) => stateGuard({
    ...state as ICommonState,
    isComponentView
  })),
  on(CommonActions.setTmsId, (state, { tmsId }) => stateGuard({
    ...state as ICommonState,
    tmsId
  })),
  on(CommonActions.pusherData, (state, { command, data }) => stateGuard({
    ...state as ICommonState,
    pusher: {
      command,
      data : {
        ...data,
        Data: (() => {
          try {
            return JSON.parse(data.Data)
          }
          catch(e) {
            return null
          }

        })()
      }
    }
  })),
  on(CommonActions.setIsShowNavigation, (state, { isShowNavigation }) => stateGuard({
    ...state as ICommonState,
    isShowNavigation
  })),
  on(CommonActions.setIsShowFooter, (state, { isShowFooter }) => stateGuard({
    ...state as ICommonState,
    isShowFooter
  })),
  on(CommonActions.setIsAuthenticated, (state, { isAuthenticated }) => stateGuard({
    ...state as ICommonState,
    isAuthenticated
  })),
  on(CommonActions.setErrorAPI, (state, { isErrorAPI }) => stateGuard({
    ...state as ICommonState,
    isErrorAPI
  })),
  on(CommonActions.qaTesting, (state, { qaTesting }) => stateGuard({
    ...state as ICommonState,
    qaTesting
  })),
  on(CommonActions.setToDismissModal, (state, { isDismiss }) => stateGuard({
    ...state as ICommonState,
    isDismissModal: isDismiss
  })),
  on(CommonActions.backNavigation, (state, { sourceInitiator }) => stateGuard({
    ...state as ICommonState,
    backNavigation: sourceInitiator + '-' + String((new Date()).getMilliseconds() * (Math.floor(Math.random() + 9999)))
  })),
  on(CommonActions.isConnectedInternet, (state, { sourceInitiator, isConnected }) => stateGuard({
    ...state as ICommonState,
    isConnectedInternet: {
      isConnected,
      sourceInitiator
    }
  })),

);

export const commonReducer = (state: ICommonState | undefined, action: Action) => {
  return reducer(state, action);
}
